"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _resize = _interopRequireDefault(require("../../../hocs/resize"));
var _Tab = _interopRequireDefault(require("../../../components/common/Tab/Tab"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _OrderBookContainer = _interopRequireDefault(require("../../../components/OrderBookComponents/OrderBookContainer"));
var _InstrumentRow = _interopRequireDefault(require("../../../components/InstrumentRow"));
var _ConfirmLimitOrderModalContainer = _interopRequireDefault(require("../../../components/ConfirmLimitOrderModal/ConfirmLimitOrderModalContainer"));
var _MarginClosePositionModal = _interopRequireDefault(require("../../../components/MarginClosePosition/MarginClosePositionModal"));
var _MarginTransferAssetsModal = _interopRequireDefault(require("../../../components/MarginTransferAssetModal/MarginTransferAssetsModal"));
var _PriceChartContainer = _interopRequireDefault(require("../../../components/PriceChart/PriceChartContainer"));
var _DepthChartContainer = _interopRequireDefault(require("../../../components/DepthChart/DepthChartContainer"));
var _TradingLayoutCharts1280Px = _interopRequireDefault(require("../../Responsive/TrandingLayout/TradingLayoutCharts1280Px"));
var _config = _interopRequireDefault(require("../../../config"));
var _OrderHistoryComponents = _interopRequireDefault(require("../../../components/OrderHistoryComponents"));
var _MarginOrderHistory = _interopRequireDefault(require("../../../components/OrderHistoryComponents/MarginOrderHistory"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var tradingLayoutClasses = (0, _cssClassesHelper.getBEMClasses)('trading-layout');
var orderEntryClasses = (0, _cssClassesHelper.getBEMClasses)('order-entry');
var recentTradeClasses = (0, _cssClassesHelper.getBEMClasses)('recent-trade');
var orderBookClasses = (0, _cssClassesHelper.getBEMClasses)('order-book');
var flexTableClasses = (0, _cssClassesHelper.getBEMClasses)('flex-table');
var TradingLayout1280Px = function TradingLayout1280Px(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var renderActivity = function renderActivity() {
    var config = props.config,
      isMarginActive = props.isMarginActive;
    var usePagination = config.OrderHistoryData.usePagination,
      maxLines = config.TradingLayout.maxLines;
    var orderHistoryConfig = {
      usePagination: usePagination,
      maxLines: maxLines,
      filterMode: 'selectedInstrument'
    };
    return isMarginActive ? /*#__PURE__*/_react["default"].createElement(_MarginOrderHistory["default"], {
      config: orderHistoryConfig
    }) : /*#__PURE__*/_react["default"].createElement(_OrderHistoryComponents["default"], {
      config: orderHistoryConfig
    });
  };
  var OrderBook = props.OrderBook,
    RecentTrades = props.RecentTrades,
    OrderEntry = props.OrderEntry,
    InstrumentPositions = props.InstrumentPositions,
    _short = props["short"],
    isMarginEnabledSelector = props.isMarginEnabledSelector;
  var _getPanesForFirstColumn = function _getPanesForFirstColumn() {
    return [{
      menuItem: t('Order Book'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: orderBookClasses('container')
        }, /*#__PURE__*/_react["default"].createElement(OrderBook, null));
      }
    }, {
      menuItem: t('Recent Trades'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: recentTradeClasses('container')
        }, /*#__PURE__*/_react["default"].createElement(RecentTrades, null));
      }
    }];
  };
  var _getPanesForSecondColumn = function _getPanesForSecondColumn() {
    return [{
      menuItem: t('Order Entry'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(OrderEntry, null);
      }
    }, {
      menuItem: t('Balances'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(InstrumentPositions, {
          showTitle: false
        });
      }
    }];
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_InstrumentRow["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('chart-container')
  }, _short ? /*#__PURE__*/_react["default"].createElement(_TradingLayoutCharts1280Px["default"], {
    "short": props["short"],
    PriceChart: _PriceChartContainer["default"],
    DepthChart: _DepthChartContainer["default"],
    showDepthChart: _config["default"].TradingLayout.showDepthChart
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('chart-header')
  }, t('Price Chart')), /*#__PURE__*/_react["default"].createElement(_PriceChartContainer["default"], null), _config["default"].TradingLayout.showDepthChart && /*#__PURE__*/_react["default"].createElement(_DepthChartContainer["default"], null))), _short ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('tabs-container', 'orderbook-container')
  }, /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
    panes: _getPanesForFirstColumn(),
    customClass: "trading-layout"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: orderEntryClasses('container', 'orderentry-container')
  }, /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
    panes: _getPanesForSecondColumn(),
    customClass: "trading-layout"
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('tabs-container', 'orderbook-container')
  }, /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
    panes: _getPanesForFirstColumn(),
    customClass: "trading-layout"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: orderEntryClasses('container', 'orderentry-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: flexTableClasses('title')
  }, t('Order Entry')), /*#__PURE__*/_react["default"].createElement(OrderEntry, null), /*#__PURE__*/_react["default"].createElement(InstrumentPositions, null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('activity-container')
  }, renderActivity())), /*#__PURE__*/_react["default"].createElement(_ConfirmLimitOrderModalContainer["default"], null), isMarginEnabledSelector && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MarginClosePositionModal["default"], null), /*#__PURE__*/_react["default"].createElement(_MarginTransferAssetsModal["default"], null)));
};
TradingLayout1280Px.defaultProps = {
  OrderBook: _OrderBookContainer["default"]
};
TradingLayout1280Px.propTypes = {
  "short": _propTypes["default"].bool,
  OrderBook: _propTypes["default"].func.isRequired,
  RecentTrades: _propTypes["default"].func.isRequired,
  OrderEntry: _propTypes["default"].func.isRequired,
  InstrumentPositions: _propTypes["default"].func.isRequired
};
TradingLayout1280Px.defaultProps = {
  "short": false
};
var _default = exports["default"] = (0, _resize["default"])(TradingLayout1280Px);